// Full 18 Charm Bracelet Builder V4

document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.ic-v4');
  if (!root) return;

  const sectionId = root.dataset.sectionId;
  const builderVariantId = root.dataset.builderVariantId;

  const storageKey = 'charmed_ic_v4_current_' + sectionId;
  const builtKey = 'charmed_ic_v4_built_' + sectionId;

  const fontDataEl = document.getElementById('icV4FontData-' + sectionId);
  const builderFonts = fontDataEl ? JSON.parse(fontDataEl.textContent || '[]') : [];

  builderFonts.forEach(function (font) {
    const style = document.createElement('style');
    style.textContent =
      '@font-face{font-family:"' + font.family + '";src:url("' + font.url + '") format("woff2");font-display:swap;}';
    document.head.appendChild(style);
  });

  const braceletNameInput = document.getElementById('icV4BraceletName');
  const slotsEl = document.getElementById('icV4BraceletSlots');
  const previewHeading = document.getElementById('icV4PreviewHeading');
  const helperText = document.getElementById('icV4HelperText');
  const summaryEl = document.getElementById('icV4BraceletSummary');
  const saveMessage = document.getElementById('icV4SaveMessage');

  const chooseBtn = document.getElementById('icV4ChooseCharms');
  const saveBtn = document.getElementById('icV4SaveBracelet');
  const shareBtn = document.getElementById('icV4ShareBracelet');
  const clearBtn = document.getElementById('icV4ClearBracelet');
  const cartBtn = document.getElementById('icV4AddToCart');

  const drawer = document.getElementById('icV4CharmDrawer');
  const closeDrawer = document.getElementById('icV4CloseDrawer');
  const charmsGrid = document.getElementById('icV4CharmsGrid');
  const collectionSelector = document.getElementById('icV4CollectionSelector');
  const searchInput = document.getElementById('icV4CharmSearch');

  const charmPickerView = document.getElementById('icV4CharmPickerView');
  const engravingView = document.getElementById('icV4EngravingView');
  const backToCharms = document.getElementById('icV4BackToCharms');
  const engravingTitle = document.getElementById('icV4EngravingTitle');
  const engravingImage = document.getElementById('icV4EngravingImage');
  const engravingText = document.getElementById('icV4EngravingText');
  const engravingCount = document.getElementById('icV4EngravingCount');
  const fontOptions = document.getElementById('icV4FontOptions');
  const addEngravedCharmBtn = document.getElementById('icV4AddEngravedCharm');

  const editPopup = document.getElementById('icV4EditPopup');
  const editPopupTitle = document.getElementById('icV4EditPopupTitle');
  const replaceCharmBtn = document.getElementById('icV4ReplaceCharm');
  const removeCharmBtn = document.getElementById('icV4RemoveCharm');
  const cancelEditBtn = document.getElementById('icV4CancelEditCharm');

  const builtPanel = document.getElementById('icV4BuiltBraceletsPanel');
  const builtList = document.getElementById('icV4BuiltBraceletsList');

  const cartSuccessModal = document.getElementById('icV4CartSuccessModal');
  const closeCartSuccessButton = document.getElementById('icV4CloseCartSuccess');
  const addAnotherBraceletButton = document.getElementById('icV4AddAnotherBracelet');
  const cartSuccessBackdrop = cartSuccessModal
    ? cartSuccessModal.querySelector('[data-close-cart-modal]')
    : null;

  const braceletSize = 18;
  let braceletName = '';
  let selectedCharms = Array(braceletSize).fill(null);
  let activeSlotIndex = null;
  let editingSlotIndex = null;
  let pendingEngravedCharm = null;
  let selectedFontIndex = 0;
  let loadedProducts = [];
  let allProducts = [];
  let loadedCollections = {};

  function isRealCharm(item) {
    return item && !item.covered;
  }

  function getCharmCount() {
    return selectedCharms.filter(isRealCharm).length;
  }

  function getUsedSlots() {
    return selectedCharms.filter(function (item) {
      return item !== null;
    }).length;
  }

  function getFirstEmptySlot() {
    return selectedCharms.findIndex(function (item) {
      return item === null;
    });
  }

  function productHasTag(product, tagName) {
    if (!product.tags) return false;

    if (Array.isArray(product.tags)) {
      return product.tags.includes(tagName);
    }

    return String(product.tags)
      .split(',')
      .map(function (tag) {
        return tag.trim();
      })
      .includes(tagName);
  }

  function getStartIndex(index) {
    const item = selectedCharms[index];

    if (!item) return index;
    if (item.covered) return item.parentIndex;

    return index;
  }

  function clearCharmAt(index) {
    const startIndex = getStartIndex(index);
    const item = selectedCharms[startIndex];

    if (!isRealCharm(item)) return;

    const size = Number(item.slotSize || 1);

    for (let i = 0; i < size; i++) {
      selectedCharms[startIndex + i] = null;
    }
  }

  function canPlaceCharmAt(index, slotSize) {
    if (index < 0 || index + slotSize > braceletSize) return false;

    for (let i = 0; i < slotSize; i++) {
      if (selectedCharms[index + i] !== null) return false;
    }

    return true;
  }

  function placeCharmAt(index, charm) {
    index = getStartIndex(index);

    clearCharmAt(index);

    const slotSize = Number(charm.slotSize || 1);

    if (!canPlaceCharmAt(index, slotSize)) {
      alert(slotSize === 2 ? 'This double charm needs 2 open links next to each other.' : 'This space is not available.');
      return false;
    }

    selectedCharms[index] = charm;

    if (slotSize === 2) {
      selectedCharms[index + 1] = {
        covered: true,
        parentIndex: index
      };
    }

    return true;
  }

  function normaliseCharmsArray() {
    selectedCharms = selectedCharms.slice(0, braceletSize);

    while (selectedCharms.length < braceletSize) {
      selectedCharms.push(null);
    }
  }

  function getCurrentDesign() {
    return {
      braceletName: braceletName,
      selectedCharms: selectedCharms
    };
  }

  function applyDesign(data) {
    if (!data) return;

    braceletName = data.braceletName || '';
    braceletNameInput.value = braceletName;

    selectedCharms = Array.isArray(data.selectedCharms)
      ? data.selectedCharms.slice(0, braceletSize)
      : Array(braceletSize).fill(null);

    normaliseCharmsArray();
  }

  function saveCurrent(showMessage) {
    localStorage.setItem(storageKey, JSON.stringify(getCurrentDesign()));

    if (showMessage) {
      saveMessage.textContent = 'Your bracelet has been saved on this device.';
      setTimeout(function () {
        saveMessage.textContent = '';
      }, 3000);
    }
  }

 function loadCurrent() {
  try {
    let sharedDesign = null;

    // New share links use the URL hash.
    if (window.location.hash) {
      const hashParams = new URLSearchParams(
        window.location.hash.substring(1)
      );

      sharedDesign = hashParams.get('design');
    }

    // Fallback support for older query-string links.
    if (!sharedDesign) {
      const urlParams = new URLSearchParams(window.location.search);
      sharedDesign = urlParams.get('design');
    }

    if (sharedDesign) {
      const decodedDesign = decodeDesign(sharedDesign);

      applyDesign(decodedDesign);
      saveCurrent(false);

      saveMessage.textContent = 'Shared bracelet design loaded.';

      setTimeout(function () {
        saveMessage.textContent = '';
      }, 3000);

      return;
    }

    const saved = localStorage.getItem(storageKey);

    if (saved) {
      applyDesign(JSON.parse(saved));

      saveMessage.textContent =
        'Welcome back! We restored your saved bracelet.';

      setTimeout(function () {
        saveMessage.textContent = '';
      }, 3000);
    }
  } catch (error) {
    console.error('Could not restore bracelet design:', error);

    saveMessage.textContent =
      'The shared bracelet link could not be loaded.';
  }
}

  function getBuiltBracelets() {
    try {
      return JSON.parse(localStorage.getItem(builtKey) || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveBuiltBracelets(items) {
    localStorage.setItem(builtKey, JSON.stringify(items));
  }

  function getBraceletLabel(fallbackNumber) {
    return braceletName.trim() || 'Bracelet ' + fallbackNumber;
  }

  function updatePreviewHeading() {
    const name = braceletName.trim();
    previewHeading.textContent = name ? name + "'s Bracelet" : 'Your Bracelet';
  }

  function updateHelperText() {
    const used = getUsedSlots();

    if (used === 0) {
      helperText.textContent = 'Choose 18 charms to complete your bracelet.';
    } else if (used >= braceletSize) {
      helperText.textContent = 'Your bracelet is complete. Tap a charm to replace or remove it.';
    } else {
      helperText.textContent = 'Keep choosing charms until all 18 links are filled.';
    }
  }

  function closeEditPopup() {
    editPopup.classList.remove('open');
    editingSlotIndex = null;
  }

  function openEditPopup(index, slotElement) {
    const startIndex = getStartIndex(index);
    const charm = selectedCharms[startIndex];

    if (!isRealCharm(charm)) return;

    editingSlotIndex = startIndex;
    editPopupTitle.textContent = charm.title;

    const rect = slotElement.getBoundingClientRect();
    editPopup.style.left = Math.min(rect.left, window.innerWidth - 210) + 'px';
    editPopup.style.top = Math.max(rect.top - 150, 20) + 'px';
    editPopup.classList.add('open');
  }

  function fitEngravingText(element, item) {
    if (!element) return;

    const isDouble = Number(item.slotSize || 1) === 2;
    const maxWidth = isDouble ? 78 : 38;
    const maxHeight = isDouble ? 36 : 30;

    let fontSize = isDouble ? 20 : 15;
    const minFontSize = isDouble ? 7 : 6;

    element.style.width = maxWidth + 'px';
    element.style.maxWidth = maxWidth + 'px';
    element.style.height = maxHeight + 'px';
    element.style.fontSize = fontSize + 'px';

    while (
      (element.scrollWidth > maxWidth || element.scrollHeight > maxHeight) &&
      fontSize > minFontSize
    ) {
      fontSize -= 0.5;
      element.style.fontSize = fontSize + 'px';
    }
  }

  function updateBracelet() {
    updatePreviewHeading();
    updateHelperText();

    slotsEl.innerHTML = '';
    slotsEl.style.gridTemplateColumns = 'repeat(18, 48px)';

    selectedCharms.forEach(function (item, index) {
      if (item && item.covered) return;

      const slot = document.createElement('div');
      slot.className = 'ic-slot';
      slot.dataset.index = index;

      if (isRealCharm(item) && Number(item.slotSize || 1) === 2) {
        slot.classList.add('ic-slot-double');
        slot.style.gridColumn = 'span 2';
      }

      if (isRealCharm(item)) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || 'Charm';

        const imageWrapper = document.createElement('div');
        imageWrapper.className = 'ic-slot-image-wrapper';

        if (
          item.type === 'engraved' &&
          Number(item.slotSize || 1) === 2
        ) {
          imageWrapper.classList.add('ic-engraved-double-image');
        }

        imageWrapper.appendChild(img);
        slot.appendChild(imageWrapper);

        if (item.type === 'engraved' && item.engravingText) {
          const engravingOverlay = document.createElement('span');
          engravingOverlay.className = 'ic-slot-engraving';
          engravingOverlay.textContent = item.engravingText;

          const engravingLines = item.engravingText.split('\n');

          if (engravingLines.length > 1) {
            engravingOverlay.classList.add('ic-engraving-two-lines');
          }

          if (item.engravingFontFamily) {
            engravingOverlay.style.fontFamily =
              '"' + item.engravingFontFamily + '"';
          }

          slot.appendChild(engravingOverlay);

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              fitEngravingText(engravingOverlay, item);
            });
          });
        }
      } else {
        slot.textContent = '+';
      }

      slot.addEventListener('click', function (event) {
        event.stopPropagation();

        if (isRealCharm(selectedCharms[index])) {
          openEditPopup(index, slot);
        } else {
          activeSlotIndex = index;
          showCharmPicker();
          openDrawer();
        }
      });

      slotsEl.appendChild(slot);
    });

    summaryEl.textContent = getUsedSlots() + ' / 18 slots filled';

    saveCurrent(false);
  }

  function showCharmPicker() {
    charmPickerView.hidden = false;
    engravingView.hidden = true;
    pendingEngravedCharm = null;
  }

  function openDrawer() {
    drawer.classList.add('open');

    if (collectionSelector && collectionSelector.value) {
      loadCollectionProducts(collectionSelector.value);
    }
  }

  function closeDrawerPanel() {
    drawer.classList.remove('open');
    activeSlotIndex = null;
    showCharmPicker();
  }

  function createCharmCard(product, collectionHandle) {
    const variant = product.variants[0];
    if (!variant || !variant.available) return '';

    const engraved = productHasTag(product, 'bbengraved');
    const slotSize = productHasTag(product, 'slot_2') ? 2 : 1;

    const image =
      product.images && product.images.length
        ? product.images[0].src
        : '';

    const braceletImage =
      engraved && product.images && product.images.length > 1
        ? product.images[1].src
        : image;

    return (
      '<div class="ic-charm-card" ' +
      'data-collection="' + collectionHandle + '" ' +
      'data-title="' + product.title.toLowerCase().replace(/"/g, '&quot;') + '" ' +
      'data-display-title="' + product.title.replace(/"/g, '&quot;') + '" ' +
      'data-variant-id="' + variant.id + '" ' +
      'data-slot-size="' + slotSize + '" ' +
      'data-engraved="' + engraved + '" ' +
      'data-image="' + braceletImage + '">' +
      (image ? '<img src="' + image + '" alt="' + product.title + '" loading="lazy">' : '') +
      '<h3>' + product.title + '</h3>' +
      (slotSize === 2 ? '<p class="ic-double-note">Double charm · uses 2 links</p>' : '') +
      (engraved ? '<p class="ic-double-note">Personalised charm</p>' : '') +
      '<button type="button">Choose</button>' +
      '</div>'
    );
  }

  async function loadCollectionProducts(collectionHandle) {
    if (loadedCollections[collectionHandle]) {
      loadedProducts = loadedCollections[collectionHandle];
      renderProducts(collectionHandle);
      return;
    }

    charmsGrid.innerHTML = '<p class="ic-loading">Loading charms...</p>';

    let page = 1;
    loadedProducts = [];

    while (true) {
      const response = await fetch('/collections/' + collectionHandle + '/products.json?limit=250&page=' + page);
      const data = await response.json();

      if (!data.products || data.products.length === 0) break;

      loadedProducts = loadedProducts.concat(data.products);
      page++;
    }

    loadedCollections[collectionHandle] = loadedProducts;

    loadedProducts.forEach(function (product) {
      if (!allProducts.find(function (p) {
        return p.id === product.id;
      })) {
        allProducts.push(product);
      }
    });

    renderProducts(collectionHandle);
  }

  function renderProducts(collectionHandle) {
    const searchTerm = searchInput.value.toLowerCase().trim();

    const productsToSearch = searchTerm.length > 0 ? allProducts : loadedProducts;

    const html = productsToSearch
      .filter(function (product) {
        return product.title.toLowerCase().includes(searchTerm);
      })
      .map(function (product) {
        return createCharmCard(product, collectionHandle);
      })
      .join('');

    charmsGrid.innerHTML = html || '<p class="ic-loading">No charms found.</p>';
    attachCharmButtons();
  }

  async function preloadCollections() {
    if (!collectionSelector) return;

    const options = collectionSelector.querySelectorAll('option');

    for (const option of options) {
      if (!loadedCollections[option.value]) {
        await loadCollectionProducts(option.value);
      }
    }
  }

  function showEngravingPanel(charm) {
    pendingEngravedCharm = charm;
    selectedFontIndex = 0;

    const limit = Number(charm.slotSize || 1) === 2 ? 16 : 8;

    charmPickerView.hidden = true;
    engravingView.hidden = false;

    engravingTitle.textContent = charm.title;
    engravingImage.src = charm.image;
    engravingImage.alt = charm.title;
    engravingText.value = '';
    engravingText.maxLength = limit;
    engravingCount.textContent = '0 / ' + limit + ' characters';

    renderFontOptions();
    engravingText.focus();
  }

  function renderFontOptions() {
    const previewText = engravingText.value || 'Name';
    fontOptions.innerHTML = '';

    if (!builderFonts.length) {
      fontOptions.innerHTML = '<p class="ic-loading">No fonts added yet.</p>';
      return;
    }

    builderFonts.forEach(function (font, index) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ic-font-option' + (index === selectedFontIndex ? ' active' : '');

      button.innerHTML =
        '<span class="ic-font-preview" style="font-family:\'' + font.family + '\'">' + previewText + '</span>' +
        '<span class="ic-font-name">' + font.name + '</span>';

      button.addEventListener('click', function () {
        selectedFontIndex = index;
        renderFontOptions();
      });

      fontOptions.appendChild(button);
    });
  }

  function attachCharmButtons() {
    root.querySelectorAll('.ic-charm-card button').forEach(function (button) {
      button.addEventListener('click', function () {
        const card = this.closest('.ic-charm-card');

        if (activeSlotIndex === null) {
          activeSlotIndex = getFirstEmptySlot();
        }

        if (activeSlotIndex === -1 || activeSlotIndex === null) {
          alert('Your bracelet is full.');
          return;
        }

        const charm = {
          title: card.dataset.displayTitle,
          variantId: card.dataset.variantId,
          image: card.dataset.image,
          slotSize: Number(card.dataset.slotSize || 1),
          type: card.dataset.engraved === 'true' ? 'engraved' : 'standard'
        };

        if (charm.type === 'engraved') {
          showEngravingPanel(charm);
          return;
        }

        const placed = placeCharmAt(activeSlotIndex, charm);
        if (!placed) return;

        activeSlotIndex = null;
        updateBracelet();

        if (getFirstEmptySlot() === -1) {
          closeDrawerPanel();
        }
      });
    });
  }

  function addPendingEngravedCharm() {
    if (!pendingEngravedCharm) return;

    const text = engravingText.value.trim();

    if (!text) {
      alert('Please enter the engraving text.');
      return;
    }

    const font = builderFonts[selectedFontIndex];

    if (!font) {
      alert('Please add at least one Builder Font block.');
      return;
    }

    const charm = Object.assign({}, pendingEngravedCharm, {
      engravingText: text,
      engravingFont: font.name,
      engravingFontFamily: font.family
    });

    const placed = placeCharmAt(activeSlotIndex, charm);
    if (!placed) return;

    pendingEngravedCharm = null;
    activeSlotIndex = null;
    showCharmPicker();
    updateBracelet();

    if (getFirstEmptySlot() === -1) {
      closeDrawerPanel();
    }
  }

  function renderBuiltBracelets() {
    const built = getBuiltBracelets();

    if (!built.length) {
      builtPanel.hidden = true;
      builtList.innerHTML = '';
      return;
    }

    builtPanel.hidden = false;
    builtList.innerHTML = '';

    built.forEach(function (item, index) {
      const charmCount = (item.selectedCharms || []).filter(isRealCharm).length;

      const card = document.createElement('div');
      card.className = 'ic-built-card';

      card.innerHTML =
        '<div>' +
        '<h3>' + item.label + '</h3>' +
        '<p>18-link bracelet · ' + charmCount + ' charms</p>' +
        '</div>' +
        '<div class="ic-built-actions">' +
        '<button type="button" data-action="edit">Edit</button>' +
        '<button type="button" data-action="duplicate">Duplicate</button>' +
        '<button type="button" data-action="delete">Delete</button>' +
        '</div>';

     card.querySelector('[data-action="edit"]').addEventListener('click', function () {

  const confirmEdit = confirm(
    'Edit "' + item.label + '"?\n\n' +
    'Please note:\n' +
    '• Editing does NOT update the bracelet already in your cart.\n' +
    '• When you add the edited bracelet, it will be added as a NEW bracelet.\n' +
    '• If you no longer want the original bracelet, please remove it from your cart.'
  );

  if (!confirmEdit) return;

  applyDesign(item);
  updateBracelet();

  saveMessage.innerHTML =
    '📝 <strong>Editing: ' + item.label + '</strong><br>' +
    'This will create a new bracelet when you click <strong>Add Bracelet to Cart</strong>. Remember to remove the original bracelet from your cart if you no longer want it.';

  saveMessage.classList.add('ic-edit-warning');

  window.scrollTo({
    top: root.querySelector('.ic-preview').offsetTop - 30,
    behavior: 'smooth'
  });

});

      card.querySelector('[data-action="duplicate"]').addEventListener('click', function () {
        applyDesign(item);
        braceletNameInput.value = item.label + ' copy';
        braceletName = braceletNameInput.value;
        updateBracelet();
        saveMessage.textContent = 'Duplicated ' + item.label + '. You can now make changes.';
      });

      card.querySelector('[data-action="delete"]').addEventListener('click', function () {
       const confirmDelete = confirm(
  'Are you sure you want to remove "' + item.label + '" from the bracelet list?\n\n' +
  'Please note:\n' +
  '• This only removes it from this page.\n' +
  '• The bracelet will remain in your shopping cart.\n' +
  '• If you no longer want to order it, please remove it from your cart as well.'
);

if (!confirmDelete) return;

const updated = getBuiltBracelets().filter(function (_, builtIndex) {
  return builtIndex !== index;
});
        saveBuiltBracelets(updated);
        renderBuiltBracelets();
      });

      builtList.appendChild(card);
    });
  }

  function addCurrentToBuiltPanel(label) {
    const built = getBuiltBracelets();

    built.push({
      label: label,
      braceletName: braceletName,
      selectedCharms: selectedCharms
    });

    saveBuiltBracelets(built);
    renderBuiltBracelets();
  }

  function createCharmList() {
    return selectedCharms
      .map(function (item, index) {
        if (!isRealCharm(item)) return null;

        const slotSize = Number(item.slotSize || 1);
        const position = slotSize === 2 ? (index + 1) + '-' + (index + 2) : index + 1;

        let line = position + '. ' + item.title;

        if (item.type === 'engraved') {
          line += ' — Text: ' + item.engravingText + ' — Font: ' + item.engravingFont;
        }

        return line;
      })
      .filter(Boolean)
      .join('\n');
  }

  chooseBtn.addEventListener('click', function () {
    activeSlotIndex = null;
    showCharmPicker();
    openDrawer();
  });

  closeDrawer.addEventListener('click', closeDrawerPanel);
  backToCharms.addEventListener('click', showCharmPicker);

  document.addEventListener('click', function (event) {
    if (!editPopup.contains(event.target) && !event.target.closest('.ic-v4 .ic-slot')) {
      closeEditPopup();
    }
  });

  braceletNameInput.addEventListener('input', function () {
    braceletName = this.value;
    updateBracelet();
  });

  collectionSelector.addEventListener('change', function () {
    loadCollectionProducts(this.value);
  });

  searchInput.addEventListener('input', async function () {
    if (searchInput.value.trim().length > 0) {
      await preloadCollections();
    }

    renderProducts(collectionSelector.value);
  });

  clearBtn.addEventListener('click', function () {
    selectedCharms = Array(braceletSize).fill(null);
    braceletName = '';
    braceletNameInput.value = '';
    saveCurrent(true);
    updateBracelet();
  });

  saveBtn.addEventListener('click', function () {
    saveCurrent(true);
  });

 shareBtn.addEventListener('click', async function () {
  const originalButtonText = shareBtn.textContent;

  try {
    shareBtn.disabled = true;
    shareBtn.textContent = 'Creating share link...';

    const encodedDesign = encodeDesign(getCurrentDesign());

    const shareUrl = new URL(window.location.href);

    // Remove any existing search parameters or old design data.
    shareUrl.search = '';
    shareUrl.hash = '';

    // Add the complete bracelet design to the destination URL.
    shareUrl.hash = 'design=' + encodedDesign;

    const longUrl = shareUrl.toString();

    const response = await fetch(
      'https://charmed-bracelet-shortener.monique707.workers.dev',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          url: longUrl
        })
      }
    );

    let result;

    try {
      result = await response.json();
    } catch (jsonError) {
      throw new Error(
        'The shortening service returned an invalid response.'
      );
    }

    if (!response.ok || !result.success || !result.shortUrl) {
      throw new Error(
        result.message ||
        'The short bracelet link could not be created.'
      );
    }

    const shortUrl = result.shortUrl;

    if (navigator.share) {
      try {
        await navigator.share({
          title: braceletName.trim()
            ? braceletName.trim() + "'s Bracelet"
            : 'My Charm Bracelet',
          text: 'Have a look at the charm bracelet I created.',
          url: shortUrl
        });

        saveMessage.textContent = 'Bracelet shared successfully.';

        setTimeout(function () {
          saveMessage.textContent = '';
        }, 3000);

        return;
      } catch (shareError) {
        if (shareError.name === 'AbortError') {
          return;
        }

        console.warn('Native sharing failed:', shareError);
      }
    }

    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(shortUrl);

      saveMessage.textContent = 'Short share link copied.';

      setTimeout(function () {
        saveMessage.textContent = '';
      }, 3000);

      return;
    }

    window.prompt('Copy your bracelet link:', shortUrl);
  } catch (error) {
    console.error('Could not create bracelet share link:', error);

    alert(
      error.message ||
      'The share link could not be created. Please try again.'
    );
  } finally {
    shareBtn.disabled = false;
    shareBtn.textContent = originalButtonText;
  }
});

  engravingText.addEventListener('input', function () {
    const limit = engravingText.maxLength;
    engravingCount.textContent = engravingText.value.length + ' / ' + limit + ' characters';
    renderFontOptions();
  });

  addEngravedCharmBtn.addEventListener('click', addPendingEngravedCharm);

  replaceCharmBtn.addEventListener('click', function () {
    if (editingSlotIndex === null) return;

    activeSlotIndex = editingSlotIndex;
    closeEditPopup();
    showCharmPicker();
    openDrawer();
  });

  removeCharmBtn.addEventListener('click', function () {
    if (editingSlotIndex === null) return;

    clearCharmAt(editingSlotIndex);
    closeEditPopup();
    updateBracelet();
  });

  cancelEditBtn.addEventListener('click', closeEditPopup);

  function openCartSuccessModal() {
    if (!cartSuccessModal) return;

    cartSuccessModal.hidden = false;
    document.body.classList.add('ic-cart-modal-open');

    if (addAnotherBraceletButton) {
      addAnotherBraceletButton.focus();
    }
  }

  function closeCartSuccessModal() {
    if (!cartSuccessModal) return;

    cartSuccessModal.hidden = true;
    document.body.classList.remove('ic-cart-modal-open');
  }

  if (closeCartSuccessButton) {
    closeCartSuccessButton.addEventListener('click', closeCartSuccessModal);
  }

  if (cartSuccessBackdrop) {
    cartSuccessBackdrop.addEventListener('click', closeCartSuccessModal);
  }

  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      cartSuccessModal &&
      !cartSuccessModal.hidden
    ) {
      closeCartSuccessModal();
    }
  });

  if (addAnotherBraceletButton) {
    addAnotherBraceletButton.addEventListener('click', function () {
      closeCartSuccessModal();

      selectedCharms = Array(braceletSize).fill(null);
      braceletName = '';
      braceletNameInput.value = '';
      activeSlotIndex = null;
      editingSlotIndex = null;

      saveMessage.classList.remove('ic-edit-warning', 'ic-share-box');
      saveCurrent(false);
      updateBracelet();

      root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }

  cartBtn.addEventListener('click', function () {
    if (getUsedSlots() < braceletSize) {
      alert('Please fill all 18 bracelet slots before adding to cart.');
      return;
    }

    if (!builderVariantId) {
      alert('Please select the Build Your Bracelet product in the section settings.');
      return;
    }

    const currentCount = getBuiltBracelets().length + 1;
    const braceletLabel = getBraceletLabel(currentCount);
    const charmList = createCharmList();

    const item = {
      id: Number(builderVariantId),
      quantity: 1,
      properties: {
        'Bracelet name': braceletLabel,
        'Selected charms': charmList,
        'Number of charms': getCharmCount()
      }
    };
    cartBtn.disabled = true;

    fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  body: JSON.stringify(item)
})
  .then(function (response) {
    if (!response.ok) {
      return response.json()
        .catch(function () {
          return {};
        })
        .then(function (errorData) {
          throw new Error(
            errorData.description ||
            errorData.message ||
            'The bracelet could not be added to your cart.'
          );
        });
    }

    return response.json();
  })
  .then(function () {
    addCurrentToBuiltPanel(braceletLabel);

    saveMessage.textContent = '';

    if (typeof openCartSuccessModal === 'function') {
      openCartSuccessModal();
    } else {
      saveMessage.textContent =
        braceletLabel + ' has been added to your cart.';
    }
  })
  .catch(function (error) {
    console.error('Could not add bracelet to cart:', error);

    alert(
      error.message ||
      'Something went wrong. Please try again.'
    );
  })
  .finally(function () {
    cartBtn.disabled = false;
  });
});
function encodeDesign(data) {
  const json = JSON.stringify(data);
  const bytes = new TextEncoder().encode(json);
  let binary = '';

  bytes.forEach(function (byte) {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

function decodeDesign(encoded) {
  let base64 = encoded
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  while (base64.length % 4) {
    base64 += '=';
  }

  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, function (character) {
    return character.charCodeAt(0);
  });

  const json = new TextDecoder().decode(bytes);

  return JSON.parse(json);
}
  loadCurrent();
  updateBracelet();
  renderBuiltBracelets();

  if (collectionSelector && collectionSelector.value) {
    loadCollectionProducts(collectionSelector.value);
  }

  setTimeout(function () {
    if (window.Sortable) {
      new Sortable(slotsEl, {
        animation: 150,
        draggable: '.ic-slot',
        onEnd: function () {
          const newOrder = [];

          root.querySelectorAll('.ic-slot').forEach(function (slot) {
            const oldIndex = Number(slot.dataset.index);
            const item = selectedCharms[oldIndex];

            if (isRealCharm(item)) {
              newOrder.push(item);

              if (Number(item.slotSize || 1) === 2) {
                newOrder.push({
                  covered: true,
                  parentIndex: newOrder.length - 1
                });
              }
            } else {
              newOrder.push(null);
            }
          });

          selectedCharms = newOrder.slice(0, braceletSize);

          while (selectedCharms.length < braceletSize) {
            selectedCharms.push(null);
          }

          updateBracelet();
        }
      });
    }
  }, 500);
});